import React, { Fragment } from 'react';
import Media from 'react-media';
import { FilterSection, FilterHeading, FilterRow } from './style';
import Searchbox from '../searchbox';

const FilterSearch = () => (
  <Media query="(min-width: 52em)">
    {matches => (
      <Fragment>
        {matches && (
          <FilterSection
            css={`
              z-index: 2;
            `}
          >
            <FilterHeading>Suche</FilterHeading>
            <FilterRow>
              <Searchbox data-placement="column" placeholder="Artikelnummer" />
            </FilterRow>
          </FilterSection>
        )}
      </Fragment>
    )}
  </Media>
);

export default FilterSearch;



// WEBPACK FOOTER //
// ../shop_main/components/filter/filterSearch.js